<div class="onboarding-step-wrapper">
    <h2>Auto-generate building assets</h2>
    <div class="onboarding-blurb">
        <p>
            An initial set of building-related assets can be automatically generated when the phase of the building is changed to the post-construction phase,
            when the project is handed-over to the facility operation.
        </p>
    </div>
    <ng-container *ngIf="!isLoading else showLoader">
        <div class="onboarding-prompt-wrapper">
            <ng-container *ngIf="active else showInactive">
                <p class="onboarding-prompt">Auto-generate building assets is on.<br/>Do you want to turn auto-generate building assets off?</p>
                <button (click)="submit(false)" class="cas-button-action">Turn off</button>
            </ng-container>

            <ng-template #showInactive>
                <p class="onboarding-prompt">Auto-generate building assets is off.<br/>Do you want to turn auto-generate building assets on?</p>
                <button (click)="submit(true)" class="cas-button-action">Turn on</button>
            </ng-template>
        </div>
    </ng-container>

    <ng-template #showLoader>
        <acabim-loading-view></acabim-loading-view>
    </ng-template>

</div>
